import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: 'default' | 'elevated';
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

/**
 * Card component with dark mode styling
 * Background: secondary-bg (#1A1A1A)
 * Border: border (#333333)
 */
export function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  ...props
}: CardProps) {
  const baseStyles = 'bg-secondary-bg border border-border rounded-lg';
  
  const variantStyles = {
    default: '',
    elevated: 'bg-tertiary-bg',
  };
  
  const paddingStyles = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
  };
  
  const classes = `${baseStyles} ${variantStyles[variant]} ${paddingStyles[padding]} ${className}`.trim();
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}












